import produce from 'immer';
import JWT from 'jsonwebtoken';
import { registerReducer } from '../../../StateSetup/RootReducer';

export const ACTION_NAME = 'action/handleStepUp';

/**
 * Sets the state with the data from the jwt received after a step up authentication
 * @param {Object} jwt
 * @param {string} sessionCorrelationId
 */
export const HandleStepUp = (jwt, sessionCorrelationId) => {
    const decodedToken = JWT.decode(jwt);

    return {
        type: ACTION_NAME,
        language: decodedToken.Identity.language.toLowerCase().startsWith('fr') ? 'fr-CA' : 'en-CA',
        isCsr: decodedToken.Identity.role.toLowerCase() === 'csr',
        isCiamSession: decodedToken.hasOwnProperty('CIAM'),
        isSteppedUp: decodedToken?.CIAM?.amr?.includes('otp'),
        group: decodedToken.Identity.group,
        ciamUuid: decodedToken.CIAM?.uuid,
        entityId: decodedToken.SSO?.entity_id,
        sessionCorrelationId,
        jwt,
    };
};

export const reducer = produce((state, action) => {
    state.Authentication.isAuthenticated = true;
    state.Authentication.jwt = action.jwt;
    state.Authentication.language = action.language;
    state.Authentication.isCsr = action.isCsr;
    state.Authentication.sessionCorrelationId = action.sessionCorrelationId;
    state.Authentication.isCiamSession = action.isCiamSession;
    state.Authentication.isSteppedUp = action.isSteppedUp;
    state.Authentication.group = action.group;
    state.Authentication.ciamUuid = action.ciamUuid;
    state.Authentication.entityId = action.entityId;
});

registerReducer(ACTION_NAME, reducer);
